export default __webpack_public_path__ + "static/media/app-bg.d34f5526.png";